import React, { useEffect, useState } from "react";
import SlideStoreLink from "../SlideStoreLink";
import { ImageComponent } from "../SlideImage";

interface Slide {
  images?: string[][];
  Component?: any;
  url: string;
  firstCopy: string;
  secondCopy: string;
  thirdCopy?: string;
  disclaimer?: string;
  googlePlayUrl?: string;
  appStoreUrl?: string;
  logo?: string;
}

const Slide = ({ slide }: { slide: Slide }) => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const handleResize = () => setWindowSize(window.innerWidth);

  const isMobile = () => windowSize <= 767;

  const carouselSlideContainerStyle = (): React.CSSProperties => {
    if (!isMobile() || !slide.images) return {};
    const image = slide.images[0][0].split("-left")[0];
    return {
      backgroundImage: `url("${image}-right.jpg")`,
      backgroundSize: "cover",
    };
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="swiper-slide">
      {slide.appStoreUrl || slide.googlePlayUrl ? (
        <div className="mmmTapesWalmart-slide-stores-wrapper">
          {slide.appStoreUrl ? (
            <SlideStoreLink url={slide.appStoreUrl} name="App Store" />
          ) : (
            ""
          )}

          {slide.googlePlayUrl ? (
            <SlideStoreLink url={slide.googlePlayUrl} name="Google Play" />
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      <a
        className="mmmTapesWalmart-carousel__link"
        href={slide.url}
        rel="external"
        tabIndex={0}
      >
        <div className="mmmTapesWalmart-carousel__content-container">
          {slide.images && <ImageComponent images={slide.images} />}
          {slide.Component && (
            <div className="swiper-lazy">
              <slide.Component />
            </div>
          )}{" "}
          <div
            className="mmmTapesWalmart-carousel__slide-copy-container"
            style={carouselSlideContainerStyle()}
          >
            <img
              className="mmmTapesWalmart-logo"
              srcSet={
                slide.logo
                  ? slide.logo
                  : `${process.env.MEDIA_URL}/media/images/carousel/logo.png 1x,
              ${process.env.MEDIA_URL}/media/images/carousel/logo@2x.png 2x,
              ${process.env.MEDIA_URL}/media/images/carousel/logo@3x.png 3x`
              }
              alt="brand logos"
              style={{ visibility: isMobile() ? "hidden" : "visible" }}
            />
            <div style={{ visibility: isMobile() ? "hidden" : "visible" }}>
              <p className="mmmTapesWalmart-carousel__slide-first-copy">
                {slide.firstCopy}
              </p>

              <p className="mmmTapesWalmart-carousel__slide-second-copy">
                {slide.secondCopy}
              </p>

              {slide.thirdCopy && (
                <p className="mmmTapesWalmart-carousel__slide-third-copy">
                  {slide.thirdCopy}
                </p>
              )}

              {slide.disclaimer && (
                <p className="mmmTapesWalmart-carousel__slide-disclaimer">
                  {slide.disclaimer}
                </p>
              )}
            </div>
          </div>
        </div>
      </a>
      <div className="swiper-lazy-preloader"></div>
    </div>
  );
};

export default Slide;
